import { IQuery, IQueryDataType, IQueryGroupType, ISearchParams, ISort } from '@patsnap/synapse_common_interface'
import { IHistorySearchParams, ISearchCollapse, ISearchHistoryFromModule } from '@pharmsnap/shared/types'
import { cloneDeep } from 'lodash'
import { sharedCtx } from 'pharmsnapMF_shared/context'

export function useFinderSearch() {
  async function getQueryIdByQuery(
    query: IQuery,
    dataType: IQueryDataType,
    fromModule?: ISearchHistoryFromModule,
    collapse?: ISearchCollapse,
    groupBy?: IQueryGroupType,
    sort?: ISort[],
    queryType?: ISearchParams['query_type']
  ) {
    const searchParams: IHistorySearchParams = {
      data_type: dataType,
      query: cloneDeep(query),
      ...(collapse ? { collapse } : undefined),
      ...(fromModule ? { from_module: fromModule } : { hidden_flag: true }),
      ...(groupBy ? { group_by: groupBy } : undefined),
      ...(sort?.length ? { sort: sort } : undefined),
      ...(queryType ? { query_type: queryType } : undefined),
    }
    const queryRes = await sharedCtx.service.history.saveQuery(searchParams)
    if (queryRes.success) {
      return queryRes.data.id
    }
    return ''
  }

  return {
    getQueryIdByQuery,
  }
}
